export const NAME = 'contact';
export const POINTER_CURSOR = 'pointer';
export const SEARCH_DEBOUNCE_TIME = 500;
export const COLUMNS_CONFIG = {
    name: {
        label: 'Name',
        is_active: true,
        required: true,
    },
    telephone: {
        label: 'Telephone',
        is_active: true,
        required: false,
    },
    email: {
        label: 'Mail',
        is_active: true,
        required: false,
    },
    company_name: {
        label: 'Company',
        is_active: true,
        required: false,
    },
    installer: {
        label: 'User',
        is_active: true,
        required: false,
    },
    projects: {
        label: 'Project_plural',
        is_active: true,
        required: false,
    },
    created_at: {
        label: 'Oldest',
        is_active: true,
        required: false,
    },
};
